import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const nine_squares_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M3.5,6.5 L6.5,6.5 L6.5,3.5 L3.5,3.5 L3.5,6.5 Z M10.5,6.5 L13.5,6.5
      L13.5,3.5 L10.5,3.5 L10.5,6.5 Z M17.5,6.5 L20.5,6.5 L20.5,3.5 L17.5,3.5 L17.5,6.5 Z M3.5,13.5
      L6.5,13.5 L6.5,10.5 L3.5,10.5 L3.5,13.5 Z M10.5,13.5 L13.5,13.5 L13.5,10.5 L10.5,10.5 L10.5,13.5 Z
      M17.5,13.5 L20.5,13.5 L20.5,10.5 L17.5,10.5 L17.5,13.5 Z M3.5,20.5 L6.5,20.5 L6.5,17.5 L3.5,17.5
      L3.5,20.5 Z M10.5,20.5 L13.5,20.5 L13.5,17.5 L10.5,17.5 L10.5,20.5 Z M17.5,20.5 L20.5,20.5 L20.5,17.5
      L17.5,17.5 L17.5,20.5 Z"
      />
    </svg>
  );
};
